import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import FormButtons from '../../components/FormButtons';
import InputPhone from '../../components/InputPhone';
import InputText from '../../components/InputText';
import Select from '../../components/Select';
import useFields from '../../hooks/useFields';
import { DEPARTMENTS, PROVINCES, DISTRICTS } from './constants';
import { formatValuesLoad } from '../index/values';

interface MyDataProps {
  idRequest: number;
  save: (
    formName: string,
    fields: any,
    isComplete: boolean,
    save: boolean
  ) => void;
  next: () => void;
  saveCallback: () => void;
}

const MyData = (props: MyDataProps) => {
  const { idRequest, next, save, saveCallback } = props;
  const [validateForm, setValidateForm] = useState(0);
  const formBse = useSelector((state: any) => state.getFormBse);
  const { formData } = formatValuesLoad(formBse?.data);
  const {
    fields,
    setFieldValue,
    setFieldError,
    formIsValid,
    formIsComplete,
    formIsEmpty
  } = useFields(formData || {});
  const {
    dataEstadoCivil,
    dataContacto,
    dataDireccion,
    dataUrbanizacion,
    dataDepartamento,
    dataProvincia,
    dataDistrito,
    dataReferencia
  } = fields;
  if (!formBse?.data) return null;

  const getProvinces = () => {
    const filteredProvinces = PROVINCES.filter(
      (province) =>
        province.departmentId?.toString() === dataDepartamento?.toString()
    );
    return filteredProvinces.length ? filteredProvinces : PROVINCES;
  };

  const getDistricts = () => {
    const filteredDistricts = DISTRICTS.filter(
      (district) =>
        district.provinceId?.toString() === dataProvincia?.toString()
    );
    return filteredDistricts.length ? filteredDistricts : DISTRICTS;
  };

  const saveForm = () => {
    setValidateForm(validateForm + 1);
    save('data', fields, formIsComplete, true);
    if (idRequest) {
      saveCallback();
    }
  };

  const getProps = () => ({
    setFieldError,
    setFieldValue,
    validateOnStart: idRequest ? idRequest > 0 && !formIsEmpty : false,
    validateForm
  });

  React.useEffect(() => {
    if (idRequest > 0 && !formIsEmpty) {
      save('data', fields, formIsComplete, false);
    }
  }, [idRequest, formIsEmpty]);

  return (
    <div style={{ padding: '16px 24px' }} data-testid="cmp-bse-form-mydata">
      <Select
        nameLabel="Estado civil"
        value={dataEstadoCivil}
        name="dataEstadoCivil"
        optionsList={formBse?.data?.[0]?.dropDownList}
        placeholder="Selecciona tu estado"
        setFieldValue={setFieldValue}
        validateOnStart={idRequest ? idRequest > 0 && !formIsEmpty : false}
        validateForm={validateForm}
      />
      <InputPhone
        name="dataContacto"
        nameLabel="Contacto"
        value={dataContacto}
        placeholder="Ingresa tu número telefónico"
        maxLength={9}
        {...getProps()}
      />

      <InputText
        name="dataDireccion"
        placeholder="Calle/Avenida/Jirón"
        value={dataDireccion}
        nameLabel="Dirección (exacta)"
        {...getProps()}
      />

      <InputText
        name="dataUrbanizacion"
        placeholder="Vía/Altura/Km"
        nameLabel="Urbanización"
        value={dataUrbanizacion}
        {...getProps()}
      />

      <Select
        nameLabel="Departamento"
        value={dataDepartamento}
        name="dataDepartamento"
        optionsList={DEPARTMENTS}
        placeholder="Selecciona tu departamento"
        setFieldValue={setFieldValue}
        validateOnStart={idRequest ? idRequest > 0 && !formIsEmpty : false}
        validateForm={validateForm}
        dependients={{ dataProvincia, dataDistrito }}
        isFilterable
      />

      <Select
        nameLabel="Provincia"
        value={dataProvincia}
        name="dataProvincia"
        optionsList={getProvinces()}
        placeholder="Selecciona tu provincia"
        setFieldValue={setFieldValue}
        validateOnStart={idRequest ? idRequest > 0 && !formIsEmpty : false}
        validateForm={validateForm}
        dependencies={{ dataDepartamento }}
      />

      <Select
        nameLabel="Distrito"
        value={dataDistrito}
        name="dataDistrito"
        optionsList={getDistricts()}
        placeholder="Selecciona tu distrito"
        setFieldValue={setFieldValue}
        validateOnStart={idRequest ? idRequest > 0 && !formIsEmpty : false}
        validateForm={validateForm}
        dependencies={{ dataDepartamento, dataProvincia }}
        isFilterable
      />

      <InputText
        name="dataReferencia"
        placeholder="Agrega datos adicionales"
        value={dataReferencia}
        nameLabel="Referencia"
        {...getProps()}
      />

      <FormButtons
        handlerSend={saveForm}
        handlerNext={next}
        formIsValid={formIsValid}
      />
    </div>
  );
};

export default MyData;
